module.exports = __webpack_public_path__ + "static/media/logo.da86bcf4.svg";